import { t } from 'i18next';
import { z } from 'zod';

export type InputOfZodSchema<T extends z.ZodType> = z.input<T>;
export type ValidatedOutputOfZodSchema<T extends z.ZodType> = z.infer<T>;

export type WorklistToDashboardDialogFormData = InputOfZodSchema<typeof worklistToDashboardDialogDataSchema>;
export type WorklistToDashboardDialogValidatedData = ValidatedOutputOfZodSchema<typeof worklistToDashboardDialogDataSchema>;

const worklistToDashboardDialogDataSchema = z
    .object({
        abbreviation: z.string().trim().min(1).max(5),
        mediumThreshold: z.coerce.number().min(1),
        highThreshold: z.coerce.number().min(1),
    })
    .refine((data) => data.mediumThreshold <= data.highThreshold, {
        error: () => t('Worklist.DashboardDialog.MediumThresholdHigherThanHighError'),
        path: ['mediumThreshold'],
    });

export const validateWorklistToDashboardDialogInputData = (inputData: WorklistToDashboardDialogFormData): z.ZodSafeParseResult<WorklistToDashboardDialogValidatedData> => {
    return worklistToDashboardDialogDataSchema.safeParse(inputData);
};

export const getValidationErrorsForWorklistDialogInput = (key: keyof WorklistToDashboardDialogValidatedData, safeParseResult: z.ZodSafeParseResult<WorklistToDashboardDialogValidatedData>): string[] | undefined => {
    const errorData = safeParseResult.error;
    if (!errorData) {
        return [];
    }

    const errorTree = z.treeifyError(errorData);
    const errorsForKey = errorTree.properties?.[key];

    return errorsForKey?.errors;
};
